'use client';
import { withOneTrust } from '@segment/analytics-consent-wrapper-onetrust';
import { AnalyticsBrowser } from '@segment/analytics-next';

import isCrawlerUserAgent from '@/utils/isCrawlerUserAgent';

let analytics: AnalyticsBrowser;

if (typeof window !== 'undefined') {
  // Only initialize analytics if not a bot
  if (!isCrawlerUserAgent()) {
    analytics = new AnalyticsBrowser();

    withOneTrust(analytics).load({
      writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY! || 'FP29TqXqMZ6m0YsnH1jO6WbfOrgaVuXI',
    });
  } else {
    // Create a no-op analytics object for bots
    analytics = {
      identify: () => {},
      track: () => {},
      page: () => {},
      group: () => {},
      alias: () => {},
      reset: () => {},
      flush: () => Promise.resolve(),
    } as unknown as AnalyticsBrowser;
  }
}

export { analytics };
